import Quill from "quill";
import type Delta from "quill-delta";
import { QUILL_BLOCK_FORMATS, QUILL_FORMATS } from "./constantsV2";
import type { QuillFormats } from "./typesV2";

export class QuillTransformer {
    private quill: Quill;

    constructor(fieldEl: HTMLElement) {
        this.quill = new Quill(fieldEl, {
            theme: undefined,
            placeholder: "",
            modules: { toolbar: false, history: { delay: 200, maxStack: 1, userOnly: false } },
            formats: QUILL_FORMATS,
        });
    }

    convertClipboardHtmlToDelta(html: string, text?: string): Delta {
        return this.quill.clipboard.convert({ html, text: text || "" });
    }

    patch(name: QuillFormats, value: string | boolean, delta: Delta): Delta {
        this.quill.setContents(delta, "silent");

        const len = Math.max(0, this.quill.getLength() - 1);

        if (len > 0) {
            if (QUILL_BLOCK_FORMATS.includes(name)) {
                this.quill.formatLine(0, len, name, value, "api");
            } else {
                this.quill.formatText(0, len, name, value, "api");

                if (name === "link" && value) {
                    this.quill.formatText(0, len, "color", false, "user");
                }
            }
        }

        const out = this.quill.getContents();

        this.quill.setText("", "silent");
        this.quill.history.clear();

        return out;
    }
}
